import defaultTheme from '../theme'

const theme: typeof defaultTheme = {
  ...defaultTheme,
}

export default theme
